import * as React from 'react'
import { DateRangePicker } from 'rsuite'
import { useTranslation } from 'react-i18next'
import {
    TextFieldSeeker,
    IconSeekers,
    DateRangePickerSeeker,
    ModalSeeker,
    RadioGroupSeeker,
    DatePickerSeeker,
    GridSeeker,
} from "ui-seeker/core"

const { beforeToday } = DateRangePicker

function TitleModal({ t }) {
    return <span>
        <IconSeekers icon="calendar-check" iconType="fontAwesome"/>
        {t('events.addEventTitle')}
    </span>
}

export default function AppCreateEventModal({ isOpen, controller, onSubmit, updateState, formData, isLoading }) {
    const { t } = useTranslation('common')
    const radioGroupData = [
        { value: "1Day", label: t('events.oneDay') },
        { value: "moreThanOneDay", label: t('events.moreThanOneDay') },
    ]
    const sliderMarks = [
        { value: '1', label: t('relevance.low') },
        { value: '2', label: t('relevance.medium') },
        { value: '3', label: t('relevance.high') },
    ]
    const { dateRange, title, description, dateType, datePicker, relevance } = formData

    return <ModalSeeker
        isOpen={isOpen}
        controller={() => controller()}
        title={<TitleModal t={t} />}
        size='xs'
        okClassName='bg-primary-top'
        onSuccess={() => {
            onSubmit()
        }}
        onCancel={() => {
            controller()
        }}
        isLoading={isLoading}
        backdropClassName='daily-price-event'
    >
        <GridSeeker container>
            <GridSeeker size={12} className="event-name">
                <TextFieldSeeker id="title" value={title} label={t('fields.name')} variant="standard" onChange={e => updateState({ title: e.target.value })} />
            </GridSeeker>
            <GridSeeker size={12} className="event-description">
                <TextFieldSeeker id="description" value={description} label={t('fields.description')} variant="standard" onChange={e => updateState({ description: e.target.value })} />
            </GridSeeker>

            <GridSeeker size={12} className="date-type">
                <RadioGroupSeeker dataRadioGroup={radioGroupData} formLabel={t('fields.date')} defaultValue={dateType} onChange={e => updateState({ dateType: e.target.value, datePicker: null, dateRange: [] })} />
            </GridSeeker>

            <GridSeeker size={12} className="selector-date">
                {dateType === '1Day' && <DatePickerSeeker id="datePicker" value={datePicker} onChange={(e) => updateState({ datePicker: e })} />}
                {dateType === 'moreThanOneDay' && <DateRangePickerSeeker
                    id="dateRange"
                    value={dateRange}
                    onChange={(e) => updateState({ dateRange: e })}
                    disabledDate={d => beforeToday()(d)}
                />}
            </GridSeeker>

            <GridSeeker size={12} className="date-type">
                <RadioGroupSeeker dataRadioGroup={sliderMarks} formLabel={t('relevance.label')} defaultValue={relevance.toString()} onChange={e => updateState({ relevance: e.target.value })} />
            </GridSeeker>
        </GridSeeker>
    </ModalSeeker>
}
